import { privacyHTML } from "./privacyHTML";

//const mySafeHTML = DOMPurify.sanitize(privacyHTML());

const privacy = () => {
  return privacyHTML();
};

export default privacy;
